<template>
	<div v-if="userLocation">
		<rich-marker :position="userLocation">
			<div class="user-location-marker"></div>
		</rich-marker>
		<gmap-marker v-if="userLocation" :position="userLocation" :visible="false" ref="marker"></gmap-marker>
	</div>
</template>
<script>
	import { gmapApi } from 'vue2-google-maps';
	import RichMarker from '../markers/RichMarker';

	export default {
		components: {
			RichMarker,
		},
		computed: {
			google: gmapApi,
			userLocation() {
				const coords = this.$store.state.location.coordinates;
				return coords ? new this.google.maps.LatLng(coords) : coords;
			}
		}
	};
</script>
<style lang="stylus">
	.user-location-marker {
		position: relative;
		display: block;
		width: 20px;
		height: 20px;
		border-radius: 50%;
		background: #3497FD;
		z-index: 1;

		&:before {
			position: absolute;
			content: '';
			display block;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
			border-radius 50%;
			background: #3497FD;
			opacity: 1;
			animation: user-ripple 1s linear infinite;
		}
	}

	@keyframes user-ripple {
		0% {
			transform: scale(.5);
			opacity: .75;
		}
		100% {
			transform: scale(2);
			opacity: 0;
		}
	}
</style>
